module.exports = __webpack_public_path__ + "static/media/icon-manage-class-linked-active.97e5fb93.svg";